import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { ContractorTransferCreated, ContractorTransferRequest } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  options?: Omit<UseMutationOptions<ContractorTransferCreated, Error, ContractorTransferRequest>, 'mutationKey' | 'mutationFn'>
}

export const useNewContractorTransferRequest = ({ options }: RequestParams = {}) => {
  const api = useApiInstance()

  return useMutation<ContractorTransferCreated, Error, ContractorTransferRequest>(
    [Entities.ContractorTransfers, 'create'],
    async (payload: ContractorTransferRequest) => {
      const { data } = await api.v1AdminContractorTransfersPost(payload)
      return data as unknown as ContractorTransferCreated
    },
    { ...options }
  )
}
